import { render, staticRenderFns } from "./RsvpGuests.vue?vue&type=template&id=649cc4e3&"
import script from "./RsvpGuests.vue?vue&type=script&lang=js&"
export * from "./RsvpGuests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports